/**
 * Derives the active subeventId from subeventMeta based on the current time.
 * If now >= startTime, the event is in-play and the inPlaySubeventId is returned.
 * Otherwise, the preMatchSubeventId is returned.
 *
 * Only the ID for the event's current phase is required. The template API can omit
 * the unused phase ID (for example, a future event may not have an in-play ID yet).
 * Keeping the validation here gives RR7 and atlas-astro the same runtime contract.
 */
export const getSubeventId = (subeventMeta?: {
  inPlaySubeventId?: number;
  preMatchSubeventId?: number;
  startTime?: string;
}): number => {
  if (!subeventMeta || typeof subeventMeta.startTime !== 'string') {
    throw new Error('subeventMeta missing or invalid startTime');
  }

  const startTime = new Date(subeventMeta.startTime);
  if (Number.isNaN(startTime.getTime())) {
    throw new Error('subeventMeta missing or invalid startTime');
  }

  const currentDatetime = new Date();
  const isInPlay = currentDatetime >= startTime;
  const idKey = isInPlay ? 'inPlaySubeventId' : 'preMatchSubeventId';
  const subeventId = subeventMeta[idKey];

  if (typeof subeventId !== 'number' || !Number.isFinite(subeventId)) {
    throw new Error(`subeventMeta missing or invalid ${idKey}`);
  }

  return subeventId;
};
